import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Form } from '../classes/form';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class FormsService {

  constructor(
    private httpClient: HttpClient, 
    private appConfigService: AppConfigService
  ) { }

  async getForms(): Promise<Form[]> {
    try {
      return await this.httpClient.get('./assets/forms.json').toPromise() as Form[];
    } catch (error) {
      console.error(error);
    }
  }

  async getFormById(formId: string): Promise<Form> {
    try {
      return (await this.getForms()).find(e => e.id === formId);
    } catch (error) {
      console.error(error);
    }
  }

  async getFormMarkUpById(formId): Promise<string> {
    try {
      const formSrc = (await (this.getFormById(formId))).src;
      return await this.httpClient.get(formSrc, { responseType: 'text' }).toPromise();
    } catch (error) {
      console.error(error);
    }
  }

  async uploadFormResponse(formResponse): Promise<boolean>{
    try {
      const config = await this.appConfigService.getAppConfig();

      // Set the groupId or it will be missing from the form
      // TODO: Move this logic to tangy-form so it happens for all responses
      formResponse.groupId = config.groupId

      const headers = new HttpHeaders();
      headers.set('formUploadToken', config.uploadKey);
      const data = await this.httpClient.post(config.formUploadURL, formResponse, {headers, observe: 'response'}).toPromise();
      return data.status === 200;
    } catch (error) {
      console.error(error);
      return false;
    }
  }
}
